import { useSuspenseQuery } from '@tanstack/react-query'
import { useRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'

export type ListLandingFilesResult = RestSchemas['Messages.Storage.ListLandingFilesResult']

export function useGetLandingFiles(namespace: string | null | undefined) {
  const { postStorageApiListLandingFiles } = useRestClient()
  const { appKey, projectId, organisationId } = useAppContext()

  return useSuspenseQuery({
    queryKey: ['listLandingFiles', appKey, projectId, organisationId, namespace],
    queryFn: async ({ signal }) => {
      if (!appKey || projectId == null) {
        throw new Error('Missing appKey or projectId for landing files')
      }
      const response = await postStorageApiListLandingFiles({
        signal,
        body: {
          appKey,
          projectId,
          organisationId: organisationId ?? undefined,
          namespace: namespace ?? '',
        },
      })
      if ('error' in response && response.error) {
        throw response.error
      }
      return response.data
    },
  })
}
